import styled from '@emotion/styled';
import { day as EDS_COLORS } from '@eventbrite/eds-settings';
import { CheckIcon, PlusIcon, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { FloatingCardLinkItem } from './types';

const EventDetail = ({ detail }: { detail: string }) => {
    return (
        <ListItem>
            <CheckIcon size="xsmall" />
            <Typography variant="body-md" color={'neutral-1000'}>
                {detail}
            </Typography>
        </ListItem>
    );
};

const LinkItem = ({ href, text }: { href: string; text: string }) => {
    return (
        <ListItem>
            <Link href={href}>
                <PlusIcon size="xsmall" />
                <Typography variant="body-md">{text}</Typography>
            </Link>
        </ListItem>
    );
};

export const EventDetails = ({ details }: { details: string[] }) => {
    return (
        <List>
            {details.map((detail, index) => (
                <EventDetail key={index} detail={detail} />
            ))}
        </List>
    );
};

export const LinkItems = ({ links }: { links: FloatingCardLinkItem[] }) => {
    return (
        <List>
            {links.map((link, index) => (
                <LinkItem key={index} href={link.href} text={link.text} />
            ))}
        </List>
    );
};

export const CardSection = ({
    title,
    body,
    isLoading,
    onClick,
}: {
    title: string;
    body: React.ReactNode;
    isLoading?: boolean;
    onClick?: (e: any) => void;
}) => {
    return (
        <Column isLoading={isLoading} onClick={onClick}>
            <TypographyWithSpacing
                space={16}
                variant="body-md-bold"
                color={'neutral-1000'}
            >
                {title}
            </TypographyWithSpacing>

            {body}
        </Column>
    );
};

export const TypographyWithSpacing = styled(Typography)<{ space: number }>`
    margin-bottom: ${({ space }) => space}px;
`;

const Column = styled.div<{ isLoading?: boolean }>`
    pointer-events: ${(props) => (props.isLoading ? 'none' : 'auto')};
    flex: 1 1 50%;
`;

export const Columns = styled.div<{ isOpen: boolean; isLoading?: boolean }>`
    pointer-events: ${(props) => (props.isLoading ? 'none' : 'auto')};
    @media (min-width: 740px) and (hover: hover) {
        visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
        display: flex;
        gap: 16px;
    }
`;

const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

const ListItem = styled.li`
    display: flex;
    gap: 8px;
    align-items: center;

    & + & {
        margin-top: 8px;
    }
`;

const Link = styled.a`
    display: flex;
    gap: 8px;
    align-items: center;
    text-decoration: none;
    color: ${EDS_COLORS.control};

    p {
        color: ${EDS_COLORS.control};
    }
`;

Link.defaultProps = {
    target: '_blank',
    rel: 'noopener noreferrer',
};
